import {Injectable} from "@angular/core";
import {InfrastructureService} from "../../infrastructure/shared/services/infrastructure.service";

@Injectable()
export class SessionService {

    constructor(
        private infrastructureService: InfrastructureService
    ) {}

    async getIsPromoteur(): Promise<boolean> {
        const stored = localStorage.getItem('is-promoteur');
        let res = false;

        if (!stored) {
            const response = await this.infrastructureService.getBatiments().toPromise();
            if (response.status === 200 && response.data && response.data.lenth) res = true;
            localStorage.setItem('is-promoteur', res ? '1' : '0');
        } else {
            if (stored === '1') res = true;
        }

        return res;
    }

}
